import React from "react";
import PESLogo from "../../icons/PES_Logo.png";
import styles from "./PDFExport.module.scss";

interface PDFFooterProps {
  pageNumber: number;
}

const PDFFooter: React.FC<PDFFooterProps> = ({ pageNumber }) => {
  return (
    <footer className={styles.pdfFooter} aria-label="Report Footer">
      <div className={styles.pdfPageNumber} aria-label="Page Number">
        <p></p>
      </div>
      <div className={styles.pdfLogoContainer} aria-label="Company Logo">
        <div className={styles.pdfLogoTextWrapper}>
          <img
            src={PESLogo}
            className={styles.pdfLogo}
            alt="PES Technologies Logo"
            height={50}
            width={50}
          />
          <p className={styles.pdfLogoText}>TECHNOLOGIES</p>
        </div>
        <div className={styles.pdfReportInfo} aria-label="Report Information">
          <p className={styles.pdfReportInfoItem}>
            P.E.S. Technologies Limited
          </p>
          <p className={styles.pdfReportInfoItem}>
            Unit 32, Diss Business Hub, Hopper Way, Diss, United Kingdom, IP22
            4GT
          </p>
        </div>
      </div>
    </footer>
  );
};

export default PDFFooter;
